import React, { Component } from 'react';
import Popover from 'material-ui/Popover';
import PopoverWithArrow from 'shared/components/PopoverWithArrow/PopoverWithArrow';
import PropTypes from 'prop-types';
import Radium from 'radium';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import shallowEqual from 'fbjs/lib/shallowEqual';
import FlatButton from 'material-ui/FlatButton';

@Radium
export default class TooltipWrapper extends Component {

  constructor(props) {
    super(props);
    const {popoverType, defaultOpen} = this.props;
    this.state = {
      open: !!defaultOpen && !this.isDismissed(),
      anchorEl: null,
    };
    this.tooltipStyle = {
      color: Colors.white,
      fontSize: 14,
      padding: 16,
      opacity: popoverType === 'grey' ? 0.9 : 1,
      maxWidth: 200,
    };

    this.popoverStyle = {
      backgroundColor: popoverType === 'withArrow' ? Colors.blue500 : Colors.grey700,
      ...this.props.popoverStyle,
    };

    if (popoverType === 'default') {
      this.popoverStyle.boxShadow = 'none';
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
  }

  isDismissed() {
    const {tooltipId} = this.props;
    return tooltipId && window.localStorage.getItem(`tooltipDismissed-${tooltipId}`);
  }

  handleClick = () => {
    const {dismissLabel, children} = this.props;
    if (!dismissLabel || this.isDismissed() || React.Children.only(children).props.disabled) {
      return;
    }
    this.clearTimeout();
    this.setState({open: true});
  };

  handleDismissClicked = () => {
    const {tooltipId} = this.props;
    window.localStorage.setItem(`tooltipDismissed-${tooltipId}`, true);
    this.setState({open: false});
  };

  handleRequestClose = () => {
    this.clearTimeout();
    this.setState({open: false});
  };

  handleEnter = () => {
    const { enterDelay } = this.props;
    this.clearTimeout();
    this.timeout = window.setTimeout(() => {
      if (this.timeout === null) {
        return;
      }
      this.setState({open: true});
    }, enterDelay);
  };

  handleLeave = () => {
    const {leaveDelay} = this.props;
    this.clearTimeout();
    this.timeout = window.setTimeout(() => {
      if (this.timeout === null) {
        return;
      }
      this.setState({open: false});
    }, leaveDelay);
  };

  handleMouseMove = () => {
    this.setState({ open: false });
    this.handleEnter();
  }

  clearTimeout() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  render() {
    const {ignoreHoverEvents, tooltip, popoverType, tooltipClassName,
          tooltipStyle, anchorOrigin, targetOrigin, popoverProps, dismissLabel,
          enterDelay, leaveDelay, tooltipId, showOnlyOnMouseNotMove, popoverStyle, ...other} = this.props;
    const {open, anchorEl} = this.state;
    const compoundPopoverProps = {
      open,
      className: tooltipClassName,
      anchorEl: anchorEl,
      anchorOrigin,
      targetOrigin,
      style: this.popoverStyle,
      useLayerForClickAway: !!dismissLabel,
      onRequestClose: this.handleRequestClose,
      ...popoverProps,
    };
    const innerDivProps = {
      onMouseEnter: this.handleEnter,
      onMouseLeave: this.handleLeave,
      style: _.merge({}, this.tooltipStyle, tooltipStyle),
    };

    let hoverEventHandlers = {};
    if (!ignoreHoverEvents) {
      if (showOnlyOnMouseNotMove) {
        hoverEventHandlers = {
          onMouseLeave: !_.isEmpty(tooltip) ? this.handleLeave : undefined,
        };
      } else {
        hoverEventHandlers = {
          onMouseEnter: !dismissLabel && !_.isEmpty(tooltip) ? this.handleEnter : undefined,
          onMouseLeave: !_.isEmpty(tooltip) ? this.handleLeave : undefined,
        };
      }
    }

    let mouseMoveEventHandlers = {};
    if (showOnlyOnMouseNotMove) {
      mouseMoveEventHandlers = {
        onMouseMove: !dismissLabel && !_.isEmpty(tooltip) ? this.handleMouseMove : undefined,
      };
    }
    return (
      <div ref={(anchorEl) => {this.setState({anchorEl});}}
           onClick={!_.isEmpty(tooltip) ? this.handleClick : undefined}
           style={{width: 'inherit'}}
           {...hoverEventHandlers}
           {...mouseMoveEventHandlers}
           {...other}>
        {this.props.children}
        {
          !_.isEmpty(tooltip) && anchorEl &&
          (popoverType === 'withArrow' ?
            <PopoverWithArrow
              {...compoundPopoverProps}
            >
              <div {...innerDivProps}>{tooltip}</div>
              {
                dismissLabel &&
                  <div style={{display: 'flex', justifyContent: 'center', marginTop: -11, paddingBottom: 11}}>
                    <FlatButton
                      backgroundColor={Colors.blue500}
                      labelStyle={{color: Colors.white}}
                      label={dismissLabel}
                      onClick={this.handleDismissClicked}
                    />
                  </div>
              }
            </PopoverWithArrow>
            :
            <Popover {...compoundPopoverProps}>
              <div {...innerDivProps}>{tooltip}</div>
            </Popover>)
        }
      </div>
    );
  }
}

TooltipWrapper.propTypes = {
  popoverType: PropTypes.oneOf(['grey', 'withArrow']),
  leaveDelay: PropTypes.number.isRequired,
  enterDelay: PropTypes.number.isRequired,
  ignoreHoverEvents: PropTypes.bool,
  showOnlyOnMouseNotMove: PropTypes.bool,
  tooltip: PropTypes.node,
};

TooltipWrapper.defaultProps = {
  popoverType: 'withArrow',
  enterDelay: 0,
  leaveDelay: 0,
  anchorOrigin: {horizontal: 'right', vertical: 'center'},
  targetOrigin: {horizontal: 'left', vertical: 'center'},
  ignoreHoverEvents: false,
  showOnlyOnMouseNotMove: false,
  popoverStyle: {},
};